import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const visitorId = () => {
    try {
        let v = localStorage.getItem("tc_vid");
        if (!v) {
            v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).replace(/[^a-z0-9-]/gi, "");
            localStorage.setItem("tc_vid", v);
        }
        return v;
    } catch {
        return "anon-visitor";
    }
};

export const trackEvent = (payload) => {
    if (window.location.pathname.startsWith("/admin")) return;
    api.post("/track", { vid: visitorId(), path: window.location.pathname + window.location.search, ...payload }).catch(() => {});
};

export default function VisitTracker() {
    const { pathname, search } = useLocation();
    const last = useRef(null);

    useEffect(() => {
        if (last.current === pathname + search) return;
        last.current = pathname + search;
        const entry = !sessionStorage.getItem("tc_session");
        sessionStorage.setItem("tc_session", "1");
        trackEvent({ type: "pageview", entry, ref: entry ? document.referrer || null : null });
    }, [pathname, search]);

    useEffect(() => {
        const id = setInterval(() => {
            if (document.visibilityState === "visible") trackEvent({ type: "ping" });
        }, 60000);
        return () => clearInterval(id);
    }, []);

    return null;
}
